const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
const profile = [
  // 演示页面
  {
    path: 'introducer-work-manage-todo',
    name: 'IntroducerWorkManageTodo',
    meta: {
      title: '待办事项',
      auth: true,
      cache: true
    },
    component: _import('data-center/introducer-work-manage-todo/introducer-work-manage-todo.vue')
  }
]

export default profile
